import { Overlay } from "@angular/cdk/overlay";
import { Inject, Injectable, Optional } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { ToastService } from "mis-crystal-design-system/toast";
import { ToastDataService } from "mis-crystal-design-system/toast";

@Injectable()
export class TranslateToastService extends ToastService {
  constructor(overlay: Overlay, private toastDataSvc: ToastDataService, private translateSvc: TranslateService) {
    super(overlay, toastDataSvc);
  }

  displayMsg(msg: string, timeOut?: number): void {
    this.translateSvc.get(msg).subscribe(data => {
      super.displayMsg(data, timeOut);
    });
  }
}
